import styles from "./ShelfCell.module.css";

interface Props {
  shelfName: string;
  x: number;
  y: number;
  isSelected: boolean;
  onSelect: (locationId: string) => void;
}

export const ShelfCell = ({ shelfName, x, y, isSelected, onSelect }: Props) => {
  const locationId = `${shelfName}-${x}/${y}`;

  return (
    <td onClick={() => onSelect(locationId)} className={`${styles.cell} ${isSelected ? styles.checked : ""}`}>
      {(y - 1) * 3 + x}
      <div className={styles.coords}>{x}/{y}</div>
    </td>
  );
};
